<style lang="scss" scoped>
.filter-item {
  padding: 9px 12px;
  margin-left: 8px;
  border: 1px solid #e1e9ed;
  background: #fff;
  border-radius: 4px;
  color: #333333;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  transition-property: background-color, border-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ease-in;
  svg {
    path {
      transition: fill 0.2s ease-in;
    }
  }
  &:hover {
    border: 1px solid var(--primary);
    background-color: var(--primary);
    color: #fff;
    .badge {
      border-color: #fff;
    }
    svg {
      path {
        fill: #fff;
      }
    }
  }
  .check-item {
    display: flex;
    flex-flow: row;
    align-items: center;
    transition: background-color 0.2s ease-in;
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 17px;
    &:hover {
      background-color: #e1e9ed !important;
      .checkbox {
        border-color: var(--primary);
      }
    }
    &.active {
      .checkbox {
        background-color: var(--primary);
        border-color: var(--primary);
      }
    }

    .checkbox {
      height: 16px;
      width: 16px;
      flex: none;
      border: 1px solid #e1e8f1;
      border-radius: 4px;
      margin-right: 24px;
      transition: border-color 0.2s ease-in;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      color: #fff;
    }
  }

  .date-range-picker {
    padding: 32px;
    ::v-deep .picker {
      .reportrange-text {
        display: none;
      }
    }
  }

  .badge {
    height: 16px;
    width: 16px;
    border: 1px solid var(--primary);
    color: #fff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    transition-property: background-color, border-color;
    transition-duration: 0.2s;
    transition-timing-function: ease-in;
    &.active {
      background: var(--primary);
    }
  }
}
.search-input {
  padding: 9.5px 12px;
  border: 1px solid #e1e9ed;
  background: #f2f4f7;
  border-radius: 4px;
  color: #333333;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  min-width: 300px;
  transition-property: background-color, border-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ease-in;
  &:focus {
    outline: none;
    border: 1px solid var(--primary);
  }
}

.search {
  padding: 9.5px 12px;
  border: 1px solid #e1e9ed;
  background: #f2f4f7;
  border-radius: 4px;
  color: #333333;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  width: 100%;
  transition-property: background-color, border-color, color;
  transition-duration: 0.2s;
  transition-timing-function: ease-in;
  &:focus {
    outline: none;
    border: 1px solid var(--primary);
  }
}

::v-deep .items {
  max-height: 340px;
  overflow: auto;
}
::v-deep .small-text {
  font-size: 12px;
  padding-top: 4px;
  font-weight: 500;
}
</style>

<template>
  <div class="d-flex flex-row w-100 justify-content-end">
    <template v-for="(filter, filter_type) in value">
      <!-- SEARCH TYPE FILTERS:START -->
      <template v-if="filter.type === 'search'">
        <div :key="`filter_${filter_type}`" class="mr-auto">
          <input v-model="filter.value" class="search-input" type="search" placeholder="Zoek tabel ..." />
        </div>
      </template>
      <!-- SEARCH TYPE FILTERS:END -->

      <!-- SELECT TYPE FILTERS:START -->
      <template v-if="filter.type === 'select'">
        <dropdown-layout :ref="`filter_${filter_type}`" @open="search = ''" :key="`filter_${filter_type}`" class="col-auto filter-item" v-if="filter.values.length > 0">
          <template v-slot:handle>
            <slot name="items"></slot>
            <span class="c-pointer w-100 h-100 justify-content-center align-items-center d-flex">
              <span class="badge mr-8" :class="{ active: filter.selected.length > 0 }">
                <i class="fal fa-check" v-if="filter.selected.length === filter.values.length"></i>
                <i class="fal fa-minus" v-else-if="filter.selected.length > 0"></i>
              </span>
              {{ $t(`general.filters.${filter_type}`) }}
              <i-arrow-down class="ml-8 select-input-arrow"></i-arrow-down>
            </span>
          </template>

          <template v-slot:items>
            <slot name="items"></slot>
            <div class="p-8" v-if="filter.can_search">
              <input class="search" type="text" placeholder="Zoek ..." v-model="search" />
            </div>
            <div
              v-for="filter_item in filter.values.filter(v => v.label.toLowerCase().includes(search.toLowerCase()))"
              :key="filter_item.value"
              class="item check-item"
              :class="{ active: filter.selected.includes(filter_item.value) }"
              @click="toggleFilter(filter, filter_item.value)"
            >
              <div class="checkbox">
                <i class="fal fa-check" v-if="filter.selected.includes(filter_item.value)"></i>
              </div>
              <div v-html="filter_item.label"></div>
            </div>
          </template>
        </dropdown-layout>
      </template>
      <!-- SELECT TYPE FILTERS:END -->

      <!-- DATE TYPE FILTERS:START -->
      <template v-if="filter.type === 'date'">
        <dropdown-layout :key="`filter_${filter_type}`" class="col-auto filter-item" width="600px">
          <template v-slot:handle>
            <span class="c-pointer w-100 h-100 justify-content-center align-items-center d-flex">
              {{ $t(`general.filters.${filter_type}`) }}
            </span>
          </template>
          <template v-slot:items>
            <div class="date-range-picker">
              <date-range-picker class="picker" v-model="filter.selected" single-date-picker="range" opens="inline" :ranges="datePresets" :auto-apply="true" ref="picker"></date-range-picker>
            </div>
          </template>
        </dropdown-layout>
      </template>
      <!-- Date TYPE FILTERS:END -->
    </template>
  </div>
</template>

<script>
import DropdownLayout from '@/layouts/dropdown';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  name: 'table-filters',

  components: { DropdownLayout, DateRangePicker },

  props: {
    value: {
      default: () => [],
    },
  },

  data() {
    return {
      datePresets: {},
      search: '',
    };
  },

  mounted() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);

    this.datePresets = {
      Vandaag: [today, today],
      Gisteren: [yesterday, yesterday],
      'Dit jaar': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
      Reset: [null, null],
    };
  },

  methods: {
    toggleFilter(filter, value) {
      filter.selected.includes(value) ? filter.selected.splice(filter.values.indexOf(value, 1)) : filter.selected.push(value);

      this.$emit('input', this.value);
    },
  },
};
</script>
